import React from 'react';
import { DatoCmsInformationSectionComplexImage, DatoCmsLink } from '../../../schema/datocms/blocks';
import { getColumnSpanClass, getColumnStartClass } from '../../../utilities';
import HtmlEntityTextComponent from '../../html-entity-text/html-entity-text-component';
import HtmlStringComponent from '../../html-string/html-string-component';
import Link from '../../link/link';
import ApiImageComponent from '../api-image/api-image-component';

const InformationSectionComplexImageComponent = ({ columnLayout,  showImageAsLink, title, showTitleAsLink, descriptionHtml, links, apiImage }: DatoCmsInformationSectionComplexImage): React.ReactElement => {
    const link: DatoCmsLink | undefined = links && links.length > 0 ? links[0] : undefined;

    let titleContent: JSX.Element = (<span className="flex-shrink-0 font-serif text-6xl font-semibold text-brand-primary">
        { <HtmlEntityTextComponent text={title} /> }
    </span>);
    if (showTitleAsLink && link) {
        titleContent = (
            <Link
                className="flex-shrink-0"
                internalPageReference={link.internalPageReference}
                internalPageSectionId={link.internalSectionComponentId}
                externalPageUrl={link.externalPageUrl}
                title={link.descriptiveTitle}
            >{titleContent}</Link>);
    }

    let imageContent: JSX.Element | undefined = undefined;
    if (apiImage && apiImage[0]){
        imageContent = (
            <ApiImageComponent apiImage={apiImage[0]} />
        );

        if (showImageAsLink && link) {
            imageContent = (
                <Link
                    className="flex-shrink-0"
                    internalPageReference={link.internalPageReference}
                    internalPageSectionId={link.internalSectionComponentId}
                    externalPageUrl={link.externalPageUrl}
                    title={link.descriptiveTitle}
                >{imageContent}</Link>);
        }
    }

    const gridColumnSpanClass: string = getColumnSpanClass(columnLayout);
    const gridColumnStartClass: string = getColumnStartClass(columnLayout);
    const videoItem = (
        <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className={`flex flex-col lg:flex-row items-center space-x-4 lg:${gridColumnStartClass} lg:${gridColumnSpanClass}`}>
                {titleContent}

                {imageContent}

                <HtmlStringComponent htmlString={descriptionHtml} />
            </div>
        </div>
    );

    return videoItem;
};

export default InformationSectionComplexImageComponent;
